<form [formGroup]="formGroup">
  @for (p of prefFields?.controls; track p; let i = $index) {
    <mat-checkbox class="preference" [checked]="p.value" [disabled]="!allowEditing" (click)="toggleSelection(i)">
      @if (data[i]?.categoryName.length > 140) {
        <span [glxyTooltip]="data[i]?.categoryName">
          {{ data[i]?.categoryName | truncate: 140 }}
        </span>
      } @else {
        {{ data[i]?.categoryName }}
      }
    </mat-checkbox>
  }
</form>
